export default __webpack_public_path__ + "static/media/img-slider-siamblockchain-9.d5844e20.png";